module.exports = __webpack_public_path__ + "static/media/sg10tj538.b47cdad6.png";